export const isCreateDealValid = ({ createDeal, tier, priority, amazonasin, fiction_id, work_id }: any) =>
  createDeal === 'true' &&
  tier &&
  priority &&
  ((amazonasin && amazonasin.length > 0) ||
   (fiction_id && fiction_id.length > 0) ||
   (work_id && work_id.length > 0));

export const clearCRMFilterValues = (filterData) => {
  const { createDeal, priority, tier, assignee, ...rest } = filterData;

  return { ...rest, createDeal: undefined, priority: undefined, tier: undefined, assignee: undefined };
};